module.exports = __webpack_public_path__ + "static/media/11_edited.e7b90582.jpg";